module.exports = __webpack_public_path__ + "img/sleepbuds.bb0a1fc7.png";